import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../../../styles.css";
import "./navbar.css";
import darkLogo from "../../../assets/dark-logo.webp";

const Navbar = () => {
  // When true, navbar has shadow (on scroll)
  const [scrolled, setScrolled] = useState(false);

  // Mobile hamburger menu toggle
  const [menuOpen, setMenuOpen] = useState(false);

  // React Router utilities
  const navigate = useNavigate();
  const location = useLocation();

  // Close mobile menu
  const closeAllDropdowns = () => {
    setMenuOpen(false);
  };

  // Close dropdowns automatically when page changes
  useEffect(() => {
    closeAllDropdowns();
  }, [location.pathname]);

  // Add shadow to navbar when user scrolls down
  useEffect(() => {
    let rafId = null;
    const handleScroll = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        setScrolled(window.scrollY > 10);
        rafId = null;
      });
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, []);

  // Navigates after closing dropdowns to avoid leftover menus
  const handleLinkNavigation = (path) => (e) => {
    e.preventDefault();
    closeAllDropdowns();
    setTimeout(() => {
      navigate(path);
    }, 10); // Delay ensures dropdowns disappear before page transition
  };

  // Handles testimonials scroll-to behavior
  const handleTestimonialsClick = (e) => {
    e.preventDefault();
    setMenuOpen(false);
    if (location.pathname === "/job-seekers") {
      const el = document.getElementById("testimonials");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      navigate("/job-seekers", { state: { scrollTo: "testimonials" } });
    }
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1180);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1180);
    };
    let timer;
    const debouncedResize = () => {
      clearTimeout(timer);
      timer = setTimeout(handleResize, 150);
    };
    window.addEventListener("resize", debouncedResize);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", debouncedResize);
    };
  }, []);
  
  

  return (
    <>
      <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
        <div className="nav-left">
          <Link to="/" onClick={(e) => {
            if (location.pathname === "/") {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }
          }}>
            <img width={320} height={116} decoding="async" src={darkLogo} alt="RAIN" className="logo" />
          </Link>

          <div className="nav-links">
            {/* Job Seekers — plain link, no dropdown */}
            <Link to="/job-seekers">Job Seekers</Link>

            {/* Career Centers */}
            <Link to="/career-centers">Career Centers</Link>

            {/* Ambassadors */}
            <Link to="/ambassador-program">Ambassadors</Link>

            {/* Employers Dropdown */}
            {/* <div
              className="nav-item"
              onMouseEnter={() => setDropdownOpen({ ...dropdownOpen, employers: true })}
              onMouseLeave={() => setDropdownOpen({ ...dropdownOpen, employers: false })}
            >
              Employers <img decoding="async" src={dropdownIcon} alt="dropdown" className="dropdown-arrow" />
              <div className={`dropdown-menu ${dropdownOpen.employers ? "visible" : ""}`}>
              <div className="dropdown-content">
                  <Link
                    to="/employers"
                    className="dropdown-link"
                    onClick={handleLinkNavigation("/employers")}
                    onMouseEnter={() => setHoveredItem("offerings")}
                    onMouseLeave={() => setHoveredItem(null)}
                  >
                    <img decoding="async"
                      src={hoveredItem === "offerings" ? offeringsIconBlue : offeringsIcon}
                      alt="Offerings"
                      className="icon-img"
                    />
                    Offerings
                  </Link>

                  <Link
                    to="/pricing"
                    className="dropdown-link"
                    onClick={handleLinkNavigation("/pricing")}
                    onMouseEnter={() => setHoveredItem("pricing")}
                    onMouseLeave={() => setHoveredItem(null)}
                  >
                    <Tag
                      size={20}
                      color={hoveredItem === "pricing" ? "#2B55F6" : "#333"}
                      className="icon-img"
                    />
                    Pricing
                  </Link>
                </div>
              </div>
            </div> */}

            {/* <Link
              to="/employers"
              className="nav-item"
              onClick={handleLinkNavigation("/employers")}
            >
              Employers
            </Link> */}


            {/* Insights */}
            <Link to="/insights">Insights</Link>

            {/* About Us */}
            <Link to="/about">About Us</Link>

            {/* Pricing — last in the row */}
            <Link to="/pricing">Pricing</Link>

            {/* <Link to="/newsletter" onClick={handleLinkNavigation("/newsletter")}>
              Join Our Newsletter!
            </Link> */}
          </div>
        </div>

        <div className="nav-buttons">
          <a href="https://app.raincareers.com/auth?mode=signIn" className="login-btn">Log In</a>
          <a href="https://app.raincareers.com/auth?mode=signUp" className="signup-btn">Sign Up</a>

          {/* Hamburger Menu */}
          <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            <span />
            <span />
            <span />
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
{/* Mobile Menu Overlay */}


{isMobile && menuOpen && (
  <div className="mobile-menu">
    <div className="mobile-menu-header">
      <img width={320} height={116} decoding="async" src={darkLogo} alt="RAIN" className="mobile-logo" onClick={() => navigate("/")} />
      <button className="close-btn" onClick={() => setMenuOpen(false)}>✕</button>
    </div>

    <div className="mobile-links">
      {/* Job Seekers — plain link */}
      <div className="mobile-nav-section no-toggle">
        <Link to="/job-seekers" onClick={handleLinkNavigation("/job-seekers")}>Job Seekers</Link>
      </div>

      {/* Career Centers */}
      <div className="mobile-nav-section no-toggle">
        <Link to="/career-centers" onClick={handleLinkNavigation("/career-centers")}>Career Centers</Link>
      </div>

      {/* Ambassadors */}
      <div className="mobile-nav-section no-toggle">
        <Link to="/ambassador-program" onClick={handleLinkNavigation("/ambassador-program")}>Ambassadors</Link>
      </div>

      {/* <div className="mobile-nav-section" onClick={() => toggleMobileDropdown("employers")}>
  <div className={`mobile-nav-link ${mobileDropdown.employers ? "active" : ""}`}>
    <span>Employers</span>
    <img decoding="async"
      src={dropdownIcon}
      alt="dropdown"
      className={`dropdown-icon ${mobileDropdown.employers ? "rotate" : ""}`}
    />
  </div>
  {mobileDropdown.employers && (
    <div className="mobile-sub-links">
      <Link to="/employers" onClick={handleLinkNavigation("/employers")}>Offerings</Link>
      <Link to="/pricing" onClick={handleLinkNavigation("/pricing")}>Pricing</Link>
    </div>
  )}
      </div> */}



      {/* Insights */}
      <div className="mobile-nav-section no-toggle">
        <Link to="/insights" onClick={handleLinkNavigation("/insights")}>Insights</Link>
      </div>

      {/* About Us */}
      <div className="mobile-nav-section no-toggle">
        <Link to="/about" onClick={handleLinkNavigation("/about")}>About Us</Link>
      </div>

      {/* Pricing — last in the list */}
      <div className="mobile-nav-section no-toggle">
        <Link to="/pricing" onClick={handleLinkNavigation("/pricing")}>Pricing</Link>
      </div>


    </div>
  </div>
)}





    </>
  );
};

export default Navbar;
